import { Component, Output, HostBinding, EventEmitter, Renderer2, ElementRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ScvEmployeeService } from './scv.employee.service'
import { IEmp } from './emp.model'
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'scv-topbar',
  templateUrl: 'scv.topbar.html',
  styleUrls: ['scv.topbar.css']
})
export class ScvTopBarComponent {

  langs: any[]
  topBarForm: FormGroup;
  @Output() toggleMenubar: EventEmitter<any> = new EventEmitter()
  @Output() toggleHambergMenu: EventEmitter<any> = new EventEmitter()
  @Output() Userlogout: EventEmitter<any> = new EventEmitter()
  toggled: boolean = false;
  UserDetails
  topbarItemsVisible: boolean = false;
  active: boolean = false;
  selectedlanguage = new FormControl();
  // selectedlanguage = localStorage.getItem('defaultLang');
  constructor(private scvEmployeeService: ScvEmployeeService, private fb: FormBuilder, private renderer: Renderer2, private elName: ElementRef, private translate: TranslateService, public authService: AuthService) { }

  ngOnInit() {
    this.topBarForm = this.fb.group({
      selectedlanguage: [localStorage.getItem('defaultLang')]
    })
    this.selectedlanguage.patchValue(localStorage.getItem('defaultLang'))
    this.UserDetails = JSON.parse(localStorage.getItem('user'))
    this.dropdownItem();
  }


  selectlanguage(e) {
    localStorage.setItem('defaultLang', e.value);
    this.translate.use(localStorage.getItem('defaultLang'))
    this.dropdownItem();
  }

  toggleMenu() {
    this.toggled = !this.toggled
    this.topbarItemsVisible = false
    this.toggleMenubar.emit();
  }
  toggleactive() {
    this.active = !this.active
  }

  showHambergMenu() {
    this.toggleHambergMenu.emit()
    this.topbarItemsVisible = !this.topbarItemsVisible
    this.active = false
  }

  logout() {
    this.Userlogout.emit()
    localStorage.clear();
    sessionStorage.clear();
  }

  dropdownItem() {
    this.langs = [
      { label: 'English', value: 'en' },
      { label: 'French', value: 'fr' },
    ];

  }

}